import ForceLocationModal from './ForceLocationModal';

export default ForceLocationModal;
